// @ts-nocheck
import React, { useEffect } from "react";
import {
  Box,
  Grid,
  Container,
  LinearProgress,
} from "@mui/material";
import { LeftSidePanel } from "./Components/LeftPanel/LeftPanel.js";
import "reactjs-popup/dist/index.css";
import useAppContextProvider from "../AppContext/useAppContextProvider.js";
import { isEmpty } from "lodash";

import { useHistory, useLocation } from "react-router-dom";
import {
  BodyLarge,
  H7TitleLarge,
} from "../components/StyledComponents/Typography/Typography.tsx";

import usePoolsPageContext from "./context/usePoolsPageContext.js";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { GetUserUseQuery } from "../api/api.js";
import { PoolsPageHeader } from "./Components/PoolPageHeader/PoolsPageHeader.js";
import PoolNotSelectedState from "../components/StyledComponents/EmptyStates/PoolNotSelectedState.tsx";
import NoPoolsCreatedState from "../components/StyledComponents/EmptyStates/NoPoolsCreatedState.tsx";
import PoolCard from "./Components/PoolCard/PoolCard.js";
import {
  PrimaryButton,
  SecondaryButton,
} from "../components/StyledComponents/Buttons/AuradineButtons.js";
import useSiteAndGroupTreeContext from "../minerstatusV2/context/useSiteAndGroupTreeContext.js";
import { usePostOrg } from "../api/queries/usePostOrg.ts"; // Adjust the path based on the actual location of usePostOrg
import PoolCardSkeleton from "./Components/Skeletons/PoolCardSkeleton/PoolCardSkeleton.js";
import AuradineErrorState from "../components/StyledComponents/EmptyStates/AuradineErrorState.tsx";
import PageWrapper from "../components/PageWrapper/PageWrapper.js";
import { useTheme } from "../ThemeContext/ThemeContext.js";

export const HeaderContainer = React.memo((props) => {
  const { data } = props;
  const { siteSelectedName, mockData } =
    usePoolsPageContext();
  const history = useHistory();

  return (
    <Box
      className={"header-container"}
      display={"flex"}
      justifyContent="space-between"
      flexDirection="column"
      gap={4}
      marginBottom={"1.5rem"}
    >
      <Box
        className={"title-box"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
        gap={3.5}
      >
        <H7TitleLarge>Pool Configuration</H7TitleLarge>
        <BodyLarge>
          View the mining pool configuration for your site.
        </BodyLarge>
      </Box>
    </Box>
  );
});

/**
 * Represents the MinerPage component.
 * This component displays a table of miner devices and provides functionality to interact with them.
 */
export default function PoolsPage() {
  const [leftSidePanelOpen, setLeftSidePanelOpen] =
    React.useState(true);
  const [gridHeight, setGridHeight] = React.useState(0);
  const tableContainerRef = React.useRef(null);
  const history = useHistory();
  const location = useLocation();
  const { colors } = useTheme();
  // const { siteSelectedName, mockData } =
  //   usePoolsPageContext();
  const [authToken, setAuthToken] = React.useState("");
  const [queryRefreshVersion, setQueryRefreshVersion] =
    React.useState(0);
  const { getAccessTokenSilently, isAuthenticated } =
    useAuth0();

  useEffect(() => {
    const fetchToken = async () => {
      try {
        if (!isAuthenticated) {
          setAuthToken("");
          console.warn(
            "User is not authenticated. Fetching token..."
          );
          return;
        }
        const token = await getAccessTokenSilently({
          cacheMode: "cache-only",
          ignoreCache: true,
        });
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
    const interval = setInterval(() => {
      fetchToken();
    }, 5 * 60 * 1000); // Refresh every 15 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, [getAccessTokenSilently, isAuthenticated]);

  // const [skip, setSkip] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const projection =
    siteSelectedName !== "" && groupSelectedName === ""
      ? {
          [`siteConfig.${siteSelectedName}`]: 1,
          acceptedPoolUrls: 1,
        }
      : siteSelectedName !== "" && groupSelectedName !== ""
      ? {
          [`siteConfig.${siteSelectedName}.devicegroupConfig.${groupSelectedName}`]: 1,
          acceptedPoolUrls: 1,
        }
      : {};
  const {
    data: siteOrGroupConfigData,
    refetch: siteOrGroupConfigRefetch,
    isLoading: issiteOrGroupLoading,
    isFetching: isSiteOrGroupFetching,
    isFetched: isSiteOrGroupFetched,
    isError: isSiteOrGroupError,
    error: siteOrGroupConfigError,
    isRefetching: isSiteOrGroupRefetching,
  } = usePostOrg({
    open: true,
    authToken,
    ...{
      projection: projection,
    },
    enabled:
      !isEmpty(projection) && siteSelectedName !== "",
  });

  const configData =
    isSiteOrGroupFetched &&
    siteOrGroupConfigData &&
    siteOrGroupConfigData?.result
      ? siteSelectedName !== "" && groupSelectedName === ""
        ? siteOrGroupConfigData?.result?.siteConfig[
            siteSelectedName
          ]?.ztp
        : siteSelectedName !== "" &&
          groupSelectedName !== ""
        ? siteOrGroupConfigData?.result?.siteConfig[
            siteSelectedName
          ]
          ? siteOrGroupConfigData?.result?.siteConfig[
              siteSelectedName
            ].devicegroupConfig[groupSelectedName]?.ztp
          : {}
        : {}
      : {};
  const poolData = configData?.poolCfg;
  const acceptedPoolUrls =
    siteOrGroupConfigData &&
    siteOrGroupConfigData?.result &&
    siteOrGroupConfigData?.result?.acceptedPoolUrls;

  const limit = 25;
  //fetching to get userPreferences to set the tableGroup and detailGroup from user object. If not present, we are setting default values

  const {
    data: userInfo,
    isFetched: isUserInfoFetched,
    isFetching: isUserInfoFetching,
  } = useQuery({
    queryKey: ["userInfo"],
    queryFn: () => GetUserUseQuery(authToken),
    enabled: !!authToken,
  });
  const user = userInfo?.user;

  return (
    //@ts-nocheck
    <PageWrapper>
      <HeaderContainer />
      <Grid
        container
        className={"pool-page-table-container"}
        display={"flex"}
        flexDirection={"row"}
        spacing={4}
        sx={{ transition: "all 0.3s ease-in-out" }}
      >
        <Grid
          ref={tableContainerRef}
          item
          xs={12}
          sx={{
            transition: "width 0.3s ease-in-out", // Smooth transition for width
          }}
        >
          <Box
            className={"pool-page-table"}
            display={"flex"}
            flexDirection={"row"}
            backgroundColor={colors.background.paper}

            padding={"0.75rem 0  0.75rem 0"}
            borderRadius={"1rem"}
            sx={{
              transition: "width 0.3s ease-in-out", // Smooth transition for width
            }}
          >
            <LeftSidePanel
              leftSidePanelOpen={leftSidePanelOpen}
              setLeftSidePanelOpen={setLeftSidePanelOpen}
              height={gridHeight}
              authToken={authToken}
            />
            <Box
              className={"table-container"}
              display={"flex"}
              flexDirection={"column"}
              padding={"0 0.75rem 0 0.75rem"}
              height={"calc(100vh - 13rem)"}
              // overflow={"auto"}
              minWidth={"0"}
              gap={4}
              flex={3}
              flexShrink={1}
              borderLeft={"1px solid " + colors?.border?.default}
            >
              <PoolsPageHeader
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                }}
                data={poolData ? poolData : []}
                role={user ? user.role : ""}
                accessLists={acceptedPoolUrls}
                configData={configData}
                refetch={siteOrGroupConfigRefetch}
              />
              <Box
                className={"Datagrid-container"}
                display={"flex"}
                flexShrink={1}
                flexGrow={1}
                overflowY={"auto"}
                height="calc(100vh - 15rem)"
              >
                {siteSelectedName === "" &&
                  groupSelectedName === "" && (
                    <PoolNotSelectedState
                      message={
                        "Pick a site to see pool configurations"
                      }
                    />
                  )}
                {(siteSelectedName || groupSelectedName) &&
                  isSiteOrGroupFetched && <></>}
                {(siteSelectedName || groupSelectedName) &&
                  isSiteOrGroupFetched &&
                  poolData &&
                  poolData.length === 0 && (
                    <NoPoolsCreatedState
                      message={
                        "You have no pools assigned to this site yet. Add a pool configuration using the “Add” button."
                      }
                    />
                  )}
                {/* loading skeleton will go here.  */}
                {(siteSelectedName || groupSelectedName) &&
                  (isSiteOrGroupFetching ||
                    isSiteOrGroupRefetching) && (
                    <PoolCardSkeleton />
                  )}
                {(siteSelectedName || groupSelectedName) &&
                  (isSiteOrGroupError ||
                    (siteOrGroupConfigData &&
                      siteOrGroupConfigData.status !==
                        "ok")) && (
                    <AuradineErrorState
                      message={
                        "Oops! Something went wrong. Please try again."
                      }
                    />
                  )}
                {(siteSelectedName || groupSelectedName) &&
                  isSiteOrGroupFetched &&
                  !isSiteOrGroupFetching &&
                  poolData &&
                  poolData.length > 0 && (
                    <Box
                      display={"flex"}
                      flexDirection={"column"}
                      gap={4}
                      flexGrow={1}
                      maxHeight={"calc(100vh - 18rem)"}
                      style={{
                        overflowY: "scroll",
                        scrollbarWidth: "thin",
                        scrollbarbehavior: "smooth",
                      }}
                    >
                      {(siteSelectedName ||
                        groupSelectedName) &&
                        poolData &&
                        poolData.length > 0 &&
                        poolData.map((pool, index) => {
                          if (pool)
                            return (
                              <PoolCard
                                user={pool?.user}
                                url={pool?.url}
                                password={pool?.pass}
                                worker={
                                  pool?.worker
                                }
                                index={index}
                                key={index}
                                configData={configData}
                                refetch={
                                  siteOrGroupConfigRefetch
                                }
                                role={user ? user.role : ""}
                              />
                            );
                          else <></>;
                        })}
                    </Box>
                  )}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </PageWrapper>
  );
}
